/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export const BUTTON__CONTENT_CLASS = 'button__content';

export const SPINNER_CLASSNAME_PREFIX = 'ribbons-solid-button';
